export default __webpack_public_path__ + "static/media/7_pav_Osmos_Nebbia-120x120_riv_Nebbia-Ribbed-60x120.e858c9d8.jpg";